import React, { Component } from 'react';

export default class SpotifyPlayerLarge extends Component {
  render() {
    let { url, height } = this.props;
    return (
      <div className="SpotifyPlayerLarge">
      	<iframe 
          className="lozad"
      		src={url} 
      		width="100%" 
      		height={height}
      		frameBorder="0" 
      		allowtransparency="true" 
      		allow="encrypted-media"
      	></iframe>
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Media/SpotifyPlayerLarge/SpotifyPlayerLarge.js